import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../../services";

const Admintable = () => {
  const navigate = useNavigate();
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const limit = 10;

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/user/getAllUsers?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/user/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.users?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, users: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  const getRoleLabel = (role) => {
    switch (role) {
      case "admin":
        return "Admin";
      case "property_management":
        return "Property Management";
      case "event_operator":
        return "Event Manager";
      default:
        return role;
    }
  };

  // Table Columns
  const columns = [
    {
      title: "#",
      dataIndex: "",
      key: "sr",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      key: "role",
      dataIndex: "role",
      render: (data) => <Space size="middle">{getRoleLabel(data)}</Space>,
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <EditOutlined
              className="cursor-pointer delete-icon-admin"
              onClick={() => {
                navigate(`/edit-admin/${data?._id}`);
              }}
            />
          </div>
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : data?.name === "crm" ? (
              <DeleteFilled className="cursor-not-allowed delete-icon-admin fs-18" />
            ) : (
              <Popconfirm
                title="Delete the task"
                description={"Are you sure to delete this task?"}
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer delete-icon-admin" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="header4">
        <h3>Admins</h3>
        <div className="events-button">
          <Link to="/add-admin">
            <button className="cursor-pointer add-event">Add Admin</button>
          </Link>
        </div>
      </div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={adminData?.users}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
        rowKey={(record) => record?._id}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={adminData?.totalPages}
        onChange={(e) => {
          setCurrentPage(e);
          getAllAdmins(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Admintable;
